import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import firebase from 'firebase/app';
require("firebase/firestore");

const styles = theme => ({
  textField: {
    width: 170,
  },
  marginRight: {
    marginRight: theme.spacing(2),
  },
  detailContent: {
    flex: '1 1 auto',
  },
  passContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  passInfo: {
    flex: 1,
    padding: "12px 0",
  },
});

class StaffDialog extends Component {
  state = {
    open: this.props.open,
    processing: false,

    name: '',
    email: '',
    role: '',
    active: '',
  };

  startProcessing = () => {
    this.setState({ processing: true });
  }

  stopProcessing = () => {
    this.setState({ processing: false });
  }

  handleRequestClose = () => {
    this.setState({ open: false });
    this.props.onRequestClose();
  };

  submitStaff = () => {
    if (this.props.staff) {
      firebase.firestore()
        .collection("staffs")
        .doc(this.props.staff.id)
        .update({
          email: this.state.email || firebase.firestore.FieldValue.delete(),
          name: this.state.name,
          role: this.state.role,
          active: this.state.active,
          modifiedDateTime: new Date(),
        });
    } else {
      let data = {
        name: this.state.name,
        role: this.state.role,
        active: true,
        createdDateTime: new Date(),
        modifiedDateTime: new Date(),
      };

      data.email = this.state.email && this.state.email;
    
      firebase.firestore()
        .collection("staffs")
        .add(data);
    }
    this.handleRequestClose();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.state.open) {
      if (nextProps.open) {
        this.setState({
          open: nextProps.open,
          staff: nextProps.staff,
          name: nextProps.staff && nextProps.staff.name,
          email: nextProps.staff && nextProps.staff.email,
          role: (nextProps.staff && nextProps.staff.role) || '',
          active: nextProps.staff && nextProps.staff.active,
        });
      } else {
        this.setState({ open: nextProps.open, });
      }
    }
  }

  render() {
    return (
      <Dialog
        maxWidth="xs"
        disableBackdropClick
        disableEscapeKeyDown
        onClose={this.handleRequestClose}
        open={this.state.open}>
        <DialogTitle>Staff</DialogTitle>
        <DialogContent>
          <div>
            <TextField
              fullWidth
              required
              InputLabelProps={{ shrink: true, }}
              onChange={(event) => this.setState({ name: event.target.value })}
              label="Name"
              value={this.state.name || ''}
              margin="normal" />

            <TextField
              fullWidth
              InputLabelProps={{ shrink: true, }}
              onChange={(event) => this.setState({ email: event.target.value })}
              label="Email"
              value={this.state.email || ''}
              margin="normal" />

            <FormControl 
              fullWidth
              required
              margin="normal">
              <InputLabel shrink>Role</InputLabel>
              <Select
                value={this.state.role}
                onChange={ event => { this.setState({ role: event.target.value }) } }
              >
                <MenuItem value='staff'>Staff</MenuItem>
                <MenuItem value='admin'>Admin</MenuItem>
              </Select>
            </FormControl>

            {
              this.state.staff ? 
              <div>
                <br/>
                <FormControlLabel
                  control={
                    <Switch
                      checked={this.state.active}
                      onChange={ event => this.setState({ active: event.target.checked }) }
                    />
                  }
                  label="Active"
                />
              </div>
              : null
            }

          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleRequestClose} >CANCEL</Button>
          <Button 
            color="primary" 
            disabled={
              !this.state.name ||
              !this.state.role
            }
            onClick={this.submitStaff} 
          >
            SUBMIT
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

StaffDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  staff: PropTypes.object,
};

export default withStyles(styles)(StaffDialog);